import {
  cancelLabel,
  errorTitle,
  networkErrorMessage,
  tryAgainLabel
} from '@smart-tv/contexts/error-context/error-context';
import ErrorDialog from './error-dialog';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useNetwork } from '@smart-tv/hooks/use-network/use-network';
import styles from './error-dialog.module.scss';

interface Props {
  onNetworkRestored?: () => void; // effect after data has been successfully re-fetched
  onTryAgain: () => Promise<void>;
  onClose?: () => void;
  enableFadeOut?: boolean;
  setNetworkStatusOnRetry?: boolean;
  includeCloseDialogButton?: boolean;
}

export const NetworkErrorDialog = ({
  onNetworkRestored,
  onTryAgain,
  onClose,
  enableFadeOut: enableFade = false,
  setNetworkStatusOnRetry = false,
  includeCloseDialogButton = true
}: Props) => {
  const { checkNetwork, checkAndUpdateNetwork } = useNetwork();
  const [openNetworkError, setOpenNetworkError] = useState(true);

  useEffect(() => {
    const checkConnectionStatus = async () => {
      const isOnline = await checkAndUpdateNetwork();
      if (isOnline) {
        setOpenNetworkError(false);
      }
    };

    checkConnectionStatus();
  }, [checkAndUpdateNetwork]);

  const tryAgainButtonProps = {
    label: tryAgainLabel,
    onClick: async () => {
      const hasNetwork = setNetworkStatusOnRetry
        ? await checkAndUpdateNetwork()
        : await checkNetwork();

      if (hasNetwork) {
        await onTryAgain();
        onNetworkRestored?.();
      }
    }
  };

  const secondaryButtonProps = {
    label: cancelLabel,
    onClick: async () => {
      onClose?.();
      setOpenNetworkError(false);
    }
  };

  return (
    <div
      className={clsx(
        styles['network-error-dialog--fade-wrapper'],
        enableFade && styles['network-error-dialog--fade-wrapper-fade-out']
      )}
    >
      {openNetworkError && (
        <ErrorDialog
          title={errorTitle}
          message={networkErrorMessage}
          primaryButton={tryAgainButtonProps}
          secondaryButton={includeCloseDialogButton ? secondaryButtonProps : undefined}
        />
      )}
    </div>
  );
};

export default NetworkErrorDialog;
